import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/variables.css';
import Login from './pages/account/login/login';
import Schools from './pages/schools/schools';
import Dashboard from './pages/dashboard/dashboard';
import Users from './pages/users/users';
import StudentAttendance from './pages/studentattendance/studentattendance';
import UsersAdd from './pages/users/usersadd';
import AddStudentAttendance from './pages/studentattendance/addstudentattendance';
import Subjects from './pages/subjects/subjects';
import AddSubject from './pages/subjects/addsubject';
import SchoolMaster from './pages/SchoolMaster/SchoolMaster';
import AddNewSchool from './pages/SchoolMaster/addNewSchool';
import AddStudent from './pages/students/addstudent';
import Students from './pages/students/students';
import Classes from './pages/classes/classes';
import Homeworklist from './pages/homeworklist/homeworklist';
import AddHomework from './pages/homeworklist/addhomework';
import Studentacademicyear from './pages/studentacademicyear/studentacademicyear';
import Addstudentacademicyear from './pages/studentacademicyear/AddStudentAcademic';
import AddNewClass from './pages/classes/addnewclass';
import Roles from './pages/roles/roles';
import AddRoles from './pages/roles/AddRoles';
import Departments from './pages/departments/departments';
import AddDepartments from './pages/departments/AddDepartments';
import Teachersubjectmap from './pages/teachersubjectmap/teachersubjectmap';
import AddTeachersubjectmap from './pages/teachersubjectmap/addteachersubjectmap';
import Sections from './pages/sections/sections';
import AddNewSections from './pages/sections/AddNewSections';
import Feeitems from './pages/feeitems/feeitems';
import AddFeeitems from './pages/feeitems/addfeeitems';
import Feeitemslist from './pages/feeitemslist/feeitemslist';
import AddFeeitemslist from './pages/feeitemslist/addfeeitemslist';
import Timetable from './pages/timetable/timetable';
// import Addtimetable from './pages/timetable/addtimetable';
import Feediscount from './pages/feediscount/feediscount';
import Addfeediscount from './pages/feediscount/addfeediscount';
import Feeitemschedule from './pages/feeitemschedule/feeitemschedule';
import Addfeeitemschedule from './pages/feeitemschedule/addfeeitemschedule';
import SchoolCalendar from './pages/schoolcalendar/schoolcalendar';
import CreateGroups from './pages/creategroup/creategroups';
import AddCreateGroups from './pages/creategroup/addcreategroups'
import GroupMembers from './pages/groupmembers/groupmembers'
import AddGroupMembers from './pages/groupmembers/addgroupmembers'
import Periods from './pages/periods/periods';
import AddPeriods from './pages/periods/addperiods';
import Exam from './pages/exam/exam';
import AddExam from './pages/exam/addexam';
import ExamResult from './pages/Examresults/result';
import AddExamResult from './pages/Examresults/addresult';
import ViewStudent from './pages/students/viewstudent';
import Syllabus from './pages/syllabus/syllabus';
import AddSyllabus from './pages/syllabus/addsyllabus';
// import Notifications from './pages/createnotifications/createnotifications';
// import AddNotification from './pages/createnotifications/addnotification';
import Notification from './pages/createnotifications/notifications';
import AddNewNotification from './pages/createnotifications/addnewnotification'
import Grades from './pages/grades/grades';
import AddGrades from './pages/grades/addgrades';
import ExamsSchedule from './pages/examschedule/examschedule';
import AddexamSchedule from './pages/examschedule/addexamschedule';
import SendNotification from './pages/sendnotifications/sendnotifications';
import AddNotification from './pages/sendnotifications/addnotifications';
import SendFeeNotifications from './pages/sendnotifications/sendfeenotifications';
import Feeschedule from './pages/feeschedule/feeschedule';
import AddFeeschedule from './pages/feeschedule/addfeeschedule';
// import ResultDashboard from './pages/Examresults/studentresultdashboard'
import Feesstudentsschedule from './pages/feesstudentsschedule/feesstudentsschedule';
import Addfeesstudentsschedule from './pages/feesstudentsschedule/addfeesstudentsschedule';
import BulkAddResult from './pages/Examresults/bulkresultadd';
import StudentDetails from './pages/studentshistoryreports/StudentDetails';
import StudenthistoryReports from './pages/studentshistoryreports/historyreports';
import Admissionreport from './pages/admissionreport/admissionreport';
import Studentattendancereport from './pages/studentattendancetypereport/typereport';
import Dailyattendancereport from './pages/dailyattendancereport/dailyattendancereport';
// import AddEvent from './pages/schoolcalendar/addevent';
import Studentdaywiseattendancereport from './pages/studentdaywiseattendancereport/wiseattendancereport';
import SchoolStrength from './pages/schoolstrength/schoolstrength';
import FeeReceipts from './pages/feereceipts/feereceipts';
import AddFeeReceipts from './pages/feereceipts/addfeereceipts';
import Category from './pages/category/category';
import AddCategory from './pages/category/addcategory';
import Promotestudents from './pages/promotestudents/promotestudents';
import Assignlanguages from './pages/assignlaunguages/assignlanguages';
import Teachertimetable from './pages/teachertimetable/teachertimetable';

import Academicyear from './pages/academicyearfullsetup/academicyear';
import FeeCategory from './pages/feecategory/feecategory';
import AddFeeCategory from './pages/feecategory/addfeecategory';
import PrincipalDashboard from './pages/principaldashboard/principaldashboard';

import Approvals from './pages/approval/approval';
import ClasswiseStudentsReport from './pages/classwisereports/classwisestudentsreport';
import ClasswiseTeachersReport from './pages/classwisereports/classwiseteachersreport';
import ClasswiseTeacherSubject from './pages/classwisereports/classwiseteachersubject';
import SiblingsReport from './pages/siblings/siblings'
import FeeScheduleType from './pages/feescheduletype/feescheduletype';
import AddFeeScheduleType from './pages/feescheduletype/addfeesheduletype';
import HomeworkReport from './pages/homeworkreport/homeworkreport';
import PrintableReceipt from './printreceipt';
import FeeReport from './pages/feereport/feereport';
import FeeReceiptPrintReport from './pages/feerec/feereceiptprintreport';
import NotificationScheduler from "./NotificationScheduler";
import ActiveUsers from "./pages/ActiveUsers/activeusersreport";
import BulkUpdate from "./pages/students/bulkupdate";
import MonitoringReport from './pages/monitoringreport/monitoringreport';
import ExamScheduleStatusReport from './pages/examschedulestatusreport/examschedulestatusreport';
import StudentDiscountReport from './pages/feediscountreport/studentdiscountreport';
import PublishResults from './pages/publishresults/publishresults';

import ShiftMaster from './pages/shiftmaster/shift';
import AddShiftMaster from './pages/shiftmaster/addshift';
import ParollDepartment from './pages/payrolldepartmentmaster/payrolldepartment';
import AddPayrollDepartment from './pages/payrolldepartmentmaster/addpayrolldepartment';

import Designation from './pages/designation/designation';
import AddDesignation from './pages/designation/adddesignation';
import level from './pages/level/level';
import AddLevel from './pages/level/addlevel';
import Level from './pages/level/level';

import Employeeattendance from './pages/employeeattendance/employeeattendance';

import LeaveMaster from './pages/leavemaster/leavemaster';
import AddLeaveMaster from './pages/leavemaster/addnewleavemaster';
import Gallery from './pages/gallery/gallery';
import GalleryAdd from './pages/gallery/addgallery';
import LeaveEntry from './pages/leaveentry/leaveentry';
import AddLeaveEntry from './pages/leaveentry/addleaveentry';
import LeaveApproval from './pages/leaveapproval/leaveapproval';
import Salarycomponent from './pages/salarycomponent/salarycomponent';
import Addsalarycomponent from './pages/salarycomponent/addsalarycomponent';
import EmployeeDetails from './pages/EmpDeatails/EmployeeDetails';
import AddEmployeeDetails from './pages/EmpDeatails/AddEmployeDetails';
import MainLayout from './components/layout/MainLayout';
import PayrollSchedule from './pages/payrollschedule/payrollschedule';
import ViewPayroll from './pages/viewpayroll/viewpayroll';
import Buses from './pages/buses/buses';
import AddBuses from './pages/buses/addbuses';
import BusRoutes from './pages/routes/busroutes';
import AddBusRoutes from './pages/routes/addbusroutes';
import Stops from './pages/stops/stops';
import AddStops from './pages/stops/addstops';
import RouteLocation from './pages/RouteLocations/routes';
import AddRouteLocation from './pages/RouteLocations/addroutes';
import Busrouteassignment from './pages/busrouteassignment/busrouteassignment';
import Addbusrouteassignment from './pages/busrouteassignment/addbusrouteassignment';
import TripAttendance from './pages/tripattendance/tripattendance';
import StudyHelper from './pages/studyhelper/studyhelper';
import SalaryAdvance from './pages/salaryadvance/salaryadvance';
import GroupMaster from './pages/Finance/GroupMaster/GroupMaster';
import AddGroupMaster from './pages/Finance/GroupMaster/AddGroupMaster';

import AccountMaster from './pages/Finance/AccountMaster/AccountMaster';
import AddAccountMaster from './pages/Finance/AccountMaster/AddAccountMaster';

import SubAccountMaster from './pages/Finance/SubAccountMaster/SubAccountMaster';
import AddSubAccountMaster from './pages/Finance/SubAccountMaster/AddSubAccountMaster';

import GSTMaster from './pages/Finance/GSTMaster/GSTMaster';
import AddGSTMaster from './pages/Finance/GSTMaster/AddGSTMaster';

import MapAccountCode from './pages/Finance/MapAccoundCode/MapAccountCode';
import AddMapAccountCode from './pages/Finance/MapAccoundCode/AddMapAccountCode';

import ServiceMaster from './pages/Finance/ServiceMaster/ServiceMaster';
import AddServiceMaster from './pages/Finance/ServiceMaster/AddServiceMaster';

import TDSMaster from './pages/Finance/TDSMaster/TDSMaster';
import AddTDSMaster from './pages/Finance/TDSMaster/AddTDSMaster';

import TcsMaster from './pages/Finance/TcsMaster/TcsMaster';
import AddTcsMaster from './pages/Finance/TcsMaster/AddTcsMaster';

import ManageBudget from './pages/Finance/ManageBudget/ManageBudget';
import AddManageBudget from './pages/Finance/ManageBudget/AddManageBudget';
import ChartOfAccounts from "./pages/Finance/ChartOfAccounts/ChartOfAccounts";
import AddChartOfAccounts from "./pages/Finance/ChartOfAccounts/AddChartOfAccounts";
// financial year page
import FinancialYear from './pages/Finance/FinancialYear/FinancialYear';
import AddFinancialYear from './pages/Finance/FinancialYear/AddFinancialYear';
// --- Finance: Voucher Entry / Approval
import VocherEntry from './pages/Finance/VocherEntry/VocherEntry';
import AddVocherEntry from './pages/Finance/VocherEntry/AddVocherEntry';
import TransactionEntry from './pages/Finance/TransactionEntry/TransactionEntry';
import AddTransactionEntry from './pages/Finance/TransactionEntry/AddTransactionEntry';

import VocherApproval from './pages/Finance/VocherApproval/VocherApproval';
import AddVocherApproval from './pages/Finance/VocherApproval/AddVocherApproval';
// --- Finance: GST Rate Master
import GSTRateMaster from './pages/Finance/GSTRateMaster/GSTRateMaster';
import AddGSTRateMaster from './pages/Finance/GSTRateMaster/AddGSTRateMaster';
import EmployeeattendanceReport from './pages/employeeattendancereport/employeeattendancereport';

//User Metrics
import UserMetrics from './pages/usermetrics/usermetrics';
import Employeelatedays from './pages/employeelatedays/employeelatedays';
import IdGenerator from './pages/id/idgenerator';

import StudyCertificate from './pages/studycert/studycertificate';

import AccountGrouptypes from "./pages/Finance/AccountGrouptypes/AccountGrouptypes";
import AddAccountGrouptype from "./pages/Finance/AccountGrouptypes/AddAccountGrouptype";
import Gmastr from './pages/Finance/Groups/Groups';
import AddGmstr from './pages/Finance/Groups/AddGroups';
import SubLedgerEntry from './pages/Finance/Subledger/SubLedgerEntry.js';
import AddSubLedgerEntry from './pages/Finance/Subledger/AddSubLedgerEntry'

import AccountHead from './pages/Finance/accounthead/accounthead';
import AddAccountHead from './pages/Finance/accounthead/addaccounthead';
import ParentGroup from './pages/Finance/ParentGroup/ParentGroup';
import AddParentGroup from './pages/Finance/ParentGroup/AddParentGroup';
import FinanceReportsAnalytics from './pages/Finance/financereport/FinanceReportsAnalytics';
import Financedailyreport from './pages/financedailyreport/financedailyreport.js';

import InventoryList from './pages/inventory/InventoryList';
import AddInventoryItem from './pages/inventory/AddInventoryItem';
import InventoryCategory from './pages/inventory/InventoryCategory';
import AddInventoryCategory from './pages/inventory/AddInventoryCategory';
import InventoryDashboard from './pages/inventory/InventoryDashboard';
import IssueInventoryItem from './pages/inventory/IssueInventoryItem';
import InventoryIssueList from './pages/inventory/InventoryIssueList';

import PurchaseEntry from './pages/inventory/PurchaseEntry';
import PurchaseList from './pages/inventory/PurchaseList';
import OrgVisitsList from './pages/orgvisits/OrgVisitsList';
import AddOrgVisit from './pages/orgvisits/AddOrgVisit';


function App() {
  return (
    <div className="App height100">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="account/login" element={<Login />} />
          <Route element={<MainLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="schools" element={<Schools />} />
            <Route path="Users" element={<Users />} />
            <Route path="StudentAttendance" element={<StudentAttendance />} />
            <Route path="UsersAdd" element={<UsersAdd />} />
            <Route path='AddStudentAttendance' element={<AddStudentAttendance />} />
            <Route path="Subjects" element={<Subjects />} />
            <Route path="addsubject" element={< AddSubject />} />
            <Route path="schoolmaster" element={<SchoolMaster />} />
            <Route path="addnewschool" element={<AddNewSchool />} />
            <Route path="addstudent" element={<AddStudent />} />
            <Route path="students" element={<Students />} />
            <Route path="classes" element={<Classes />} />
            <Route path="homework/homeworklist" element={<Homeworklist />} />
            <Route path="addhomework" element={<AddHomework />} />
            <Route path="studentacademicyear" element={<Studentacademicyear />} />
            <Route path="addstudentacademic" element={< Addstudentacademicyear />} />
            <Route path="addnewclass" element={<AddNewClass />} />
            <Route path="roles" element={<Roles />} />
            <Route path="AddRoles" element={<AddRoles />} />
            <Route path="departments" element={<Departments />} />
            <Route path="AddDepartments" element={<AddDepartments />} />
            <Route path="Teachersubjectmap" element={<Teachersubjectmap />} />
            <Route path="addteachersubjectmap" element={< AddTeachersubjectmap />} />
            <Route path="sections" element={<Sections />} />
            <Route path="addnewsections" element={<AddNewSections />} />
            <Route path="/timetable" element={<Timetable />} />
            {/* <Route path="/addtimetable" element={<Addtimetable />} /> */}
            <Route path="feeitems" element={<Feeitems />} />
            <Route path="addfeeitems" element={<AddFeeitems />} />
            <Route path="feeitemslist" element={<Feeitemslist />} />
            <Route path="addfeeitemslist" element={<AddFeeitemslist />} />
            <Route path="feediscount" element={<Feediscount />} />
            <Route path="addfeediscount" element={<Addfeediscount />} />
            <Route path="feeitemschedule" element={<Feeitemschedule />} />
            <Route path="addfeeitemschedule" element={<Addfeeitemschedule />} />
            <Route path="schoolcalendar" element={<SchoolCalendar />} />
            <Route path="creategroups" element={<CreateGroups />} />
            <Route path="addcreategroups" element={<AddCreateGroups />} />
            <Route path="groupmembers" element={<GroupMembers />} />
            <Route path="addgroupmembers" element={<AddGroupMembers />} />
            <Route path="addperiods" element={<AddPeriods />} />
            <Route path="periods" element={<Periods />} />
            <Route path="addexam" element={<AddExam />} />
            <Route path="exam" element={<Exam />} />
            <Route path="result" element={<ExamResult />} />
            <Route path="addresult" element={<AddExamResult />} />
            <Route path="viewstudents" element={<ViewStudent />} />
            <Route path="syllabus" element={<Syllabus />} />
            <Route path="addsyllabus" element={<AddSyllabus />} />
            {/* <Route path="createnotifications" element={<Notifications />} />
          <Route path="addnotification" element={<AddNotification />} /> */}
            <Route path="grades" element={<Grades />} />
            <Route path="addgrades" element={<AddGrades />} />
            <Route path="examschedule" element={<ExamsSchedule />} />
            <Route path="addexamschedule" element={<AddexamSchedule />} />
            <Route path="sendnotifications" element={<SendNotification />} />
            <Route path="addnotifications" element={<AddNotification />} />
            <Route path="sendfeenotifications" element={<SendFeeNotifications />} />
            <Route path="feeschedule" element={<Feeschedule />} />
            <Route path="addfeeschedule" element={<AddFeeschedule />} />
            {/* <Route path="studentresultdashboard" element={<ResultDashboard />} /> */}
            <Route path="feesstudentsschedule" element={<Feesstudentsschedule />} />
            <Route path="addfeesstudentsschedule" element={<Addfeesstudentsschedule />} />
            <Route path="bulkaddresult" element={<BulkAddResult />} />
            <Route path="historyreports" element={<StudenthistoryReports />} />
            <Route path="StudentDetails/:student_id" element={<StudentDetails />} />
            <Route path="dailyattendancereport" element={<Dailyattendancereport />} />
            <Route path="admissionreport" element={<Admissionreport />} />
            <Route path="typereport" element={<Studentattendancereport />} />
            <Route path="wiseattendancereport" element={<Studentdaywiseattendancereport />} />
            <Route path="schoolstrength" element={<SchoolStrength />} />
            <Route path="feereceipts" element={<FeeReceipts />} />
            <Route path="addfeereceipts" element={<AddFeeReceipts />} />

            <Route path="promotestudents" element={<Promotestudents />} />

            <Route path="assignlanguages" element={<Assignlanguages />} />
            <Route path="teachertimetable" element={<Teachertimetable />} />


            <Route path="notifications" element={<Notification />} />
            <Route path="addnewnotification" element={<AddNewNotification />} />
            <Route path="academicyear" element={<Academicyear />} />

            <Route path="feecategory" element={<FeeCategory />} />
            <Route path="addfeecategory" element={<AddFeeCategory />} />

            <Route path="addcategory" element={<AddCategory />} />
            <Route path="category" element={<Category />} />

            <Route path="principaldashboard" element={<PrincipalDashboard />} />

            <Route path="approvals" element={<Approvals />} />
            <Route path="classwisestudentsreport" element={<ClasswiseStudentsReport />} />
            <Route path="classwiseteachersreport" element={<ClasswiseTeachersReport />} />
            <Route path="classwisetechersubject" element={<ClasswiseTeacherSubject />} />
            <Route path="siblings" element={<SiblingsReport />} />
            <Route path='feescheduletype' element={<FeeScheduleType />} />
            <Route path='addfeescheduletype' element={<AddFeeScheduleType />} />
            <Route path='homeworkreport' element={<HomeworkReport />} />
            <Route path='feereport' element={<FeeReport />} />
            <Route path='feereceiptprintreport' element={<FeeReceiptPrintReport />} />
            <Route path='/notificationSchedule' element={<NotificationScheduler />} />
            <Route path='/usersreport' element={<ActiveUsers />} />
            <Route path='/bulkupdate' element={<BulkUpdate />} />
            <Route path='/monitoringreport' element={<MonitoringReport />} />
            <Route path='/examschedulestatusreport' element={<ExamScheduleStatusReport />} />
            <Route path='/studentdiscountreport' element={<StudentDiscountReport />} />
            <Route path='/publishresults' element={<PublishResults />} />
            <Route path='/shift' element={<ShiftMaster />} />
            <Route path='/addshift' element={<AddShiftMaster />} />
            <Route path='/payrolldepartment' element={<ParollDepartment />} />
            <Route path='/addpayrolldepartment' element={<AddPayrollDepartment />} />
            <Route path='/designation' element={<Designation />} />
            <Route path='/adddesignation' element={<AddDesignation />} />
            <Route path='/level' element={<Level />} />
            <Route path='/addlevel' element={<AddLevel />} />

            <Route path='/employeeattendance' element={<Employeeattendance />} />

            <Route path='/leavemaster' element={<LeaveMaster />} />
            <Route path='/addnewleavemaster' element={<AddLeaveMaster />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/addgallery' element={<GalleryAdd />} />
            <Route path='/leave-entry' element={<LeaveEntry />} />
            <Route path='/addleaveentry' element={<AddLeaveEntry />} />
            <Route path='/leaveapproval' element={<LeaveApproval />} />
            <Route path='/salarycomponent' element={<Salarycomponent />} />
            <Route path='/Addsalarycomponent' element={<Addsalarycomponent />} />
            <Route path='/EmployeeDetails' element={<EmployeeDetails />} />
            <Route path='/AddEmployeeDetails' element={<AddEmployeeDetails />} />
            <Route path='/payrollschedule' element={<PayrollSchedule />} />
            <Route path='/viewpayroll' element={<ViewPayroll />} />
            <Route path='/buses' element={<Buses />} />
            <Route path='/addbuses' element={<AddBuses />} />
            <Route path='/routes' element={<BusRoutes />} />
            <Route path='/addbusroutes' element={<AddBusRoutes />} />
            <Route path='/stops' element={<Stops />} />
            <Route path='/addstops' element={<AddStops />} />
            <Route path='/location' element={<RouteLocation />} />
            <Route path='/addlocation' element={<AddRouteLocation />} />
            <Route path='/busassignment' element={<Busrouteassignment />} />
            <Route path='/addbusassignment' element={<Addbusrouteassignment />} />
            <Route path='/tripattendance' element={<TripAttendance />} />
            <Route path='/studyhelper' element={<StudyHelper />} />
            <Route path='/salaryadvance' element={<SalaryAdvance />} />

            {/* Finance Reports & Analytics */}
            <Route path="finance/reports" element={<FinanceReportsAnalytics />} />

            <Route path="finance/groups" element={<GroupMaster />} />
            <Route path="finance/groups/add" element={<AddGroupMaster />} />

            <Route path="finance/accounts" element={<AccountMaster />} />
            <Route path="finance/accounts/add" element={<AddAccountMaster />} />

            <Route path="finance/subaccounts" element={<SubAccountMaster />} />
            <Route path="finance/subaccounts/add" element={<AddSubAccountMaster />} />


            <Route path="finance/gste" element={<GSTMaster />} />
            <Route path="finance/gste/add" element={<AddGSTMaster />} />


            <Route path="finance/gst/mapping" element={<MapAccountCode />} />
            <Route path="finance/gst/mapping/add" element={<AddMapAccountCode />} />


            <Route path="finance/services" element={<ServiceMaster />} />
            <Route path="finance/services/add" element={<AddServiceMaster />} />


            <Route path="finance/tds" element={<TDSMaster />} />
            <Route path="finance/tds/add" element={<AddTDSMaster />} />

            <Route path="finance/tcs" element={<TcsMaster />} />
            <Route path="finance/tcs/add" element={<AddTcsMaster />} />


            <Route path="finance/budget" element={<ManageBudget />} />
            <Route path="finance/budget/add" element={<AddManageBudget />} />

            {/* financial year setup */}
            <Route path="finance/financialyear" element={<FinancialYear />} />
            <Route path="finance/financialyear/add" element={<AddFinancialYear />} />

            {/* -------- Finance: Vouchers -------- */}
            {/* Entry */}
            <Route path="finance/vouchers" element={<VocherEntry />} />
            <Route path="finance/vouchers/add" element={<AddVocherEntry />} />
            <Route path="finance/transaction" element={<TransactionEntry />} />
            <Route path="finance/transaction/add" element={<AddTransactionEntry />} />

            {/* Approval */}
            <Route path="finance/voucher-approvals" element={<VocherApproval />} />
            <Route path="finance/voucher-approvals/add" element={<AddVocherApproval />} />
            {/* Finance → GST Rate Master */}
            <Route path="finance/gst-rate" element={<GSTRateMaster />} />
            <Route path="finance/gst-rate/add" element={<AddGSTRateMaster />} />

            <Route path="/finance/chartofaccounts" element={<ChartOfAccounts />} />
            <Route path="/finance/chartofaccounts/add" element={<AddChartOfAccounts />} />


            <Route path='/employeeattendancereport' element={<EmployeeattendanceReport />} />

            <Route path='/usermetrics' element={<UserMetrics />} />
            <Route path='/latedays' element={<Employeelatedays />} />
            <Route path='/idgenerator' element={<IdGenerator />} />
            <Route path='/studycertificate' element={<StudyCertificate />} />

            <Route path='/employeeattendancereport' element={<EmployeeattendanceReport />} />

            <Route path='/usermetrics' element={<UserMetrics />} />
            <Route path='/latedays' element={<Employeelatedays />} />
            <Route path='/idgenerator' element={<IdGenerator />} />
            <Route path="/finance/account-grouptypes" element={<AccountGrouptypes />} />
            <Route path="/finance/account-grouptypes/add" element={<AddAccountGrouptype />} />

            <Route path="/finance/gmstr" element={<Gmastr />} />
            <Route path="/finance/addgmstr" element={<AddGmstr />} />
            <Route path="/finance/subledger" element={<SubLedgerEntry />} />
            <Route path="/finance/addsubledger" element={<AddSubLedgerEntry />} />


            <Route path='/finance/accounthead' element={<AccountHead />} />
            <Route path='/finance/addaccounthead' element={<AddAccountHead />} />
            <Route path="/finance/parent-group" element={<ParentGroup />} />
            <Route path="/finance/parent-group/add" element={<AddParentGroup />} />
            <Route path="/financereport" element={<Financedailyreport />} />

            <Route path="/inventorydashboard" element={<InventoryDashboard />} />
            <Route path="/issueinventory" element={<IssueInventoryItem />} />
            <Route path="/issuelist" element={<InventoryIssueList />} />
            <Route path="/inventorycategory" element={<InventoryCategory />} />
            <Route path="/addinventorycategory" element={<AddInventoryCategory />} />
            <Route path="/inventorylist" element={<InventoryList />} />
            <Route path="/addinventoryitem" element={<AddInventoryItem />} />

            <Route path="/purchaseentry" element={<PurchaseEntry />} />
            <Route path="/purchaselist" element={<PurchaseList />} />

            {/* Organization Visits & Follow-up Tracker Routes */}
            <Route path="/orgvisits" element={<OrgVisitsList />} />
            <Route path="/addorgvisit" element={<AddOrgVisit />} />

          </Route>

        </Routes>
      </Router>
    </div>
  );
}

export default App;
